import LayoutAdminAttributes from "./LayoutAdminAttributes";
export default LayoutAdminAttributes;
